import $ from "jquery";
import API from "hooks/useNotify"; 
import Func from "utils/Func";

const handleEvents = {
  CheckboxBulkRemove: {
    OnOpenDialog: function (filters, dispatch) {
      // console.log("Open dialog");
      if (filters?.isOpenModalRemoveItem) {
        dispatch({
          type: "STORE_FILTERS",
          payload: { ...filters, isOpenModalRemoveItem: false },
        });
      } else {
        dispatch({
          type: "STORE_FILTERS",
          payload: { ...filters, isOpenModalRemoveItem: true },
        });
      }
    },
    OnClick: function (evt, filters, dispatch, data) {
      const removeItems = filters?.removeItems ?? {};
      if (evt.target.checked) {
        for (const i in data) {
          const id = data[i].id;
          if (removeItems?.[id] === undefined) {
            removeItems[id] = 1;
          }
        }
      } else {
        for (const i in data) {
          const id = data[i].id;
          if (removeItems?.[id]) {
            delete removeItems[id];
          }
        }
      }
      dispatch({
        type: "STORE_FILTERS",
        payload: { ...filters, removeItems: removeItems },
      });
    },
    IsAllRemove: function (removeItems, data) {
      const n = data.length;
      let count = 0;
      let checked = true;
      for (let i = 0; i < n; i++) {
        if (removeItems?.[data[i].id]) {
          count += 1;
        } else {
          i = n;
          checked = false;
        }
      }
      if (checked && count !== n) {
        checked = false;
      }
      return checked;
    },
  },
  CheckboxRemoveItem: {
    OnClick: function (evt, filters, dispatch) {
      const removeItems = filters?.removeItems ?? {};
      const id = evt.target.value;
      if (evt.target.checked) {
        if (removeItems?.[id] === undefined) {
          removeItems[id] = 1;
        }
      } else {
        if (removeItems?.[id]) {
          delete removeItems[id];
        }
      }
      dispatch({
        type: "STORE_FILTERS",
        payload: { ...filters, removeItems: removeItems },
      });
    },
  },
  BtnConfirmRemoveItems: {
    OnClick: async function (filters, dispatch, setRemoveItem) {
      let removeItems = filters?.removeItems ?? {};
      removeItems = Object.keys(removeItems);
      if (removeItems.length === 0) {
        return "";
      }
      setRemoveItem({ status: "inprocess" });
      try {
        const response = await API.removeItems({
          removeItems: removeItems,
        });
        // console.log(response);
        if (response?.err === 1) {
          setRemoveItem({ err: 1, err_msg: response.err_msg });
        } else {
          setRemoveItem(response);
          dispatch({
            type: "STORE_FILTERS",
            payload: {
              ...filters,
              isOpenModalRemoveItem: false,
              keyChange: Func.GetKeyRandom(),
            },
          });
        }
      } catch (error) {
        console.error("Error while calling API:", error);
        setRemoveItem({ err: 1, err_msg: "Error while calling API" });
      }
    },
    OnClose: function (filters, dispatch, setRemoveItem) {
      $("body").css({ overflow: "auto" });
      setRemoveItem({ status: "", err: 0, err_msg: "" });
      dispatch({
        type: "STORE_FILTERS",
        payload: {
          ...filters,
          isOpenModalRemoveItem: false,
        },
      });
    },
  },
  BtnAddNewByEmail: {
    OnOpenDialog: function (filters, dispatch) {
      // console.log("Open dialog");
      if (filters?.isOpenModalAddNewByEmail) {
        dispatch({
          type: "STORE_FILTERS",
          payload: { ...filters, isOpenModalAddNewByEmail: false },
        });
      } else {
        dispatch({
          type: "STORE_FILTERS",
          payload: { ...filters, isOpenModalAddNewByEmail: true },
        });
      }
    },
  },
};

export default handleEvents;
